import { render, staticRenderFns } from "./DraggableListsManageCardItem.vue?vue&type=template&id=2706d502&scoped=true&"
import script from "./DraggableListsManageCardItem.vue?vue&type=script&lang=js&"
export * from "./DraggableListsManageCardItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsManageCardItem.vue?vue&type=style&index=0&id=2706d502&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706d502",
  null
  
)

export default component.exports